<template>
    <div style="width:100%;height: 100%;">
        <el-upload class="myupload" v-if="!value" :accept="accept" :disabled="disabled" :class="{isdisabled:disabled}" :action="ossurl" :multiple="true" :http-request="httpRequest" :data="ossdate" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeupload" :show-file-list="false" drag>
            <div style="width:100%;height: 100%;display: flex; flex-direction: column; justify-content: center;">
                <i class="el-icon-upload" style="margin: 0;"></i>
                <div class="el-upload__text" v-if="keyname">{{keyname}}</div>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </div>
        </el-upload>
        <div v-else class="el-upload-dragger" @click="showbig=true;">
            <img :src="value" style="max-width: 100%;height: 100%;">
        </div>
        <el-dialog :visible.sync="showbig" class="dialog-90 dialog-top10">
            <img :src="value" style="width: 100%;">
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" v-if="!disabled" @click="ondel">删 除</el-button>
                <el-button @click="showbig = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ajax from './ajax';
//多文件上传的时候,因为共用了一个ossdate,而osskey就在这个   http-request
export default {
    props: {
        value: {
            type: String,
        },
        getOssSign: {

        },
        path: {
            type: String,
        },
        keyname: {
            type: String,
            default: '',
        },
        keytime: {
            type: Boolean,
            default: true,
        },
        disabled: {
            default: false,
        },
        accept: {
            type: String,
            default: 'image/*,video/*',
        },
        imgsize: {
            type: Number,
            default: 900,
        },
        // ossurl: {
        //     type: String,
        //     default: '',  
        // }
    },
    data() {
        return {
            ossdate: {},
            showbig: false,
            ossurl: '',
            ossdateList: [],
            uploaded定时器: null,
        }
    },
    async mounted() {
        try {
            if (!this.ossdate.ossurl) this.ossdate = await this.getOssSign() || {};
            if (!this.ossdate.ossurl) throw 'getOss返回数据错误,ossurl为空!';
            this.ossdateList = [];
        } catch (error) {
            this.$Alert(error);
        }
    },
    methods: {
        indvideocover(url) {
            return new Promise((resolve, reject) => {
                const video = document.createElement('video') // 也可以自己创建video
                video.src = url // url地址 url跟 视频流是一样的
                video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
                video.currentTime = 1 // 第一帧

                video.oncanplay = () => {
                    let canvas = document.createElement('canvas') // 获取 canvas 对象
                    const ctx = canvas.getContext('2d') // 绘制2d

                    canvas.width = video.clientWidth ? video.clientWidth : 320 // 获取视频宽度
                    canvas.height = video.clientHeight ? video.clientHeight : 320 //获取视频高度
                    // 利用canvas对象方法绘图
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
                    // 转换成base64形式
                    const videoFirstImgsrc = canvas.toDataURL('image/png') // 截取后的视频封面

                    video.remove()
                    canvas.remove()
                    resolve({
                        url: videoFirstImgsrc,
                        realUrl: url,
                    })
                }
            });
        },

        async beforeupload(file) {
            let 扩展名 = (file.name.split('.')[1] || 'jpg');
            let 文件名 = file.name.split('.')[0];

            try {
                if (!this.path) throw '上传文件路径path为空!';
                if (this.path.startsWith('/')) throw '上传文件路径path不能以/开头!';
                if (!(this.ossdate || {}).ossurl) this.ossdate = await this.getOssSign() || {};
                let 过期时间 = new Date(this.ossdate.timeout);
                if (new Date() > 过期时间) {
                    this.ossdate = await this.getOssSign() || {};
                }
                if (!this.ossdate.ossurl) throw 'getOss返回数据错误,ossurl为空!';

                let name = '';
                if (this.keyname) {
                    name = this.keyname + '-' + (this.keytime ? this.keytime : new Date().getTime());
                } else {
                    name = 文件名 + '-' + new Date().getTime();
                }
                if (!name) throw '上传文件名称不能为空!';

                this.ossdate.key = this.path + name + '.' + 扩展名;
                this.ossurl = this.ossdate.ossurl;
                file.data = JSON.parse(JSON.stringify(this.ossdate));
            } catch (error) {
                this.$Alert(error);
            }

            let _this = this
            return new Promise((resolve, reject) => {
                if (扩展名 == 'mp4') {                    
                    resolve(file)
                    return;
                }
                let isLt2M = file.size / 1024 / 1024 < 10 // 判定图片大小是否小于10MB
                if (!isLt2M) {
                    reject('图片尺寸过大');
                    this.$Alert('图片尺寸过大');
                }
                let image = new Image(), resultBlob = '';
                image.src = URL.createObjectURL(file);
                image.onload = () => {
                    // 调用方法获取blob格式，方法写在下边
                    resultBlob = _this.compressUpload(image, file.type, this.imgsize);
                    resolve(resultBlob)
                }
                image.onerror = (error) => {
                    console.log('image.onerror', error);
                    reject('加载图片错误');
                    this.$Alert('图片加载错误，可能是图片文件损坏！');
                }
            });
        },
        compressUpload(image, type, s = 900) {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            let initSize = image.src.length
            let { width } = image, { height } = image;
            let w = width, h = height;

            if (width > height) {
                if (width < s) s = width;
                w = s;
                h = (w / width) * height;
            } else {
                if (height < s) s = height;
                h = s;
                w = (h / height) * width;
            }
            canvas.width = w;
            canvas.height = h;
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(image, 0, 0, width, height, 0, 0, canvas.width, canvas.height)

            // 进行最小压缩0.1
            let compressData = canvas.toDataURL(type || 'image/jpeg', 1)

            // 压缩后调用方法进行base64转Blob，方法写在下边
            let blobImg = this.dataURItoBlob(compressData)
            return blobImg
        },
        /* base64转Blob对象 */
        dataURItoBlob(data) {
            let byteString;
            if (data.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(data.split(',')[1])
            } else {
                byteString = unescape(data.split(',')[1])
            }
            let mimeString = data
                .split(',')[0]
                .split(':')[1]
                .split(';')[0];
            let ia = new Uint8Array(byteString.length)
            for (let i = 0; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i)
            }
            return new Blob([ia], { type: mimeString })
        },
        uploadError(err, file, fileList) {
            let errstr = (err.message || JSON.stringify(err));
            if (errstr.includes('AccessDenied Invalid according to Policy')) errstr = '您的电脑时间(' + new Date().format() + ')错误!';
            this.$Alert('图片上传失败！' + errstr);
        },
        uploadSuccess(err, file, fileList) {
            this.$emit('input', this.ossurl + this.ossdate.key);
            if (this.uploaded定时器) clearTimeout(this.uploaded定时器);
            this.uploaded定时器 = setTimeout(() => {
                this.$emit('uploaded', this.ossurl + this.ossdate.key, this.keyname);
            }, 500);
        },
        ondel() {
            this.showbig = false;
            this.$emit('input', '');
        },
        httpRequest(option) {
            ajax(option)
        },
    }
}
</script>

<style lang="scss">
.isdisabled,
.isdisabled .el-upload,
.isdisabled .el-upload-dragger {
    cursor: not-allowed;
}

.myupload {
    width: 100%;
    height: 100%;
    line-height: 20px;

    .el-upload {
        width: 100%;
        height: 100%;
        .el-upload-dragger {
            width: 100%;
            height: 100%;
        }
    }
}
</style>